import { storeWithoutExpiry, getWithoutExpiry } from "@/lib/localStorage";
import ga4 from "@/lib/tracking/ga4Core";

const STORAGE_KEY = "track_edit_listing";
const JOURNEY = "edit_ad";

export const trackStartEditListing = ({ target }) => {
  const eventName = "edit_ad_interaction";

  storeWithoutExpiry(STORAGE_KEY, target);

  const eventParams = {
    target,
    journey_details: JOURNEY,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackEditListingComplete = () => {
  const eventName = "edit_ad_complete";
  const target = getWithoutExpiry(STORAGE_KEY);

  const eventParams = {
    target,
    journey_details: JOURNEY,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackEditAdOptions = ({
  source,
  listingType,
  propertyCategory,
}) => {
  const eventName = "edit_ad_options";

  const eventParams = {
    method: "clicked_edit_ad",
    source,
    listing_type: listingType,
    property_category: propertyCategory,
    journey_details: "my_ads",
    target: "edit_options_view",
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackSelectEditOption = ({
  source,
  listingType,
  propertyCategory,
  target,
}) => {
  const eventName = "select_edit_ad_option";

  const eventParams = {
    method: "clicked_ad_option",
    source,
    listing_type: listingType,
    property_category: propertyCategory,
    journey_details: "my_ads",
    target,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackSaveDiscount = ({
  source,
  listingType,
  propertyCategory,
  oldPrice,
  newPrice,
}) => {
  const eventName = "save_discount_price";

  const eventParams = {
    method: "clicked_save_option",
    source,
    listing_type: listingType,
    property_category: propertyCategory,
    journey_details: "my_ads",
    target: "specify_discount_price",
    old_value: oldPrice,
    value: newPrice,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackViewSuccessDiscount = ({
  source,
  listingType,
  propertyCategory,
  oldPrice,
  newPrice,
}) => {
  const eventName = "save_discount_price_success";

  const eventParams = {
    method: "view_success_popup",
    source,
    listing_type: listingType,
    property_category: propertyCategory,
    journey_details: "my_ads",
    target: "discount_price_added",
    old_value: oldPrice,
    value: newPrice,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackCancelDiscount = ({
  source,
  listingType,
  propertyCategory,
}) => {
  const eventName = "cancel_discount";

  const eventParams = {
    method: "clicked_cancel_option",
    source,
    listing_type: listingType,
    property_category: propertyCategory,
    journey_details: "my_ads",
    target: "cancel_discount_price",
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackViewCancelDiscount = ({
  source,
  listingType,
  propertyCategory,
  inputData,
}) => {
  const eventName = "cancel_discount_popup";

  const eventParams = {
    method: "view_cancel_option_popup",
    source,
    listing_type: listingType,
    property_category: propertyCategory,
    journey_details: "my_ads",
    target: "cancel_discount_price",
    input_data: inputData,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};
